<template>
  <div>
    <van-nav-bar
      title="场馆扫码结果"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!--    <div>{{ this.$route.query.id }}</div>-->
    <!--    <div>{{ this.$route.query.code }}</div>-->
    <van-row style="padding: 15px" type="flex" justify="center">
      <van-col span="30">扫描结果</van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col span="30">
        <van-icon :color="this.status?'#07c160':'#ee0a24'" size="10rem" :name="this.status?'success':'cross'"/>
      </van-col>
    </van-row>
    <van-row style="color: #ee0a24" v-if="!this.status" type="flex" justify="center">
      <van-col span="30">
        错误原因：{{ this.fail }}
      </van-col>
    </van-row>

    <van-row v-if="this.status&&this.or==1" type="flex" justify="center">
      <van-col span="30">
        入场时间：{{ this.in }}
      </van-col>
    </van-row>


    <van-row v-if="this.status&&this.or==2" type="flex" justify="center">
      <van-col span="30">
        出场时间：{{ this.out }},训练时间(分钟):{{ this.all }}
      </van-col>
    </van-row>

    <div style="margin: 60px 0 60px 0"></div>

    <van-row type="flex" justify="center" style="margin-top: 50px">
      <van-col span="4"></van-col>
      <van-col span="20" @click="imgShow">
        <!--    <a href="http://m.zhan.com/zt/ieltsrumen86457.html">-->
        <img src="http://cdn.sport.hhstu.xyz/societies_lb2.png" style="width: 100%" alt="">
        <!--    </a>-->

      </van-col>
      <van-col span="4"></van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from 'vue';
import {ScanVenueQrCode} from "@/network/venue";
import {
  NavBar,
  Col,
  Row,
  Icon, ImagePreview
} from 'vant';

Vue.use(NavBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(ImagePreview);
export default {
  name: "VenueScanQrCode",
  data() {
    return {
      status: false,
      code: 0,
      or: 2,
      all: 0,
      in: "",
      out: "",
      fail: ""
    }
  },
  activated() {
    ScanVenueQrCode(this.$route.query.id, this.$route.query.code).then(res => {
      // console.log(res);
      this.status = res.status;
      if (res.status) {
        this.or = res.or;
        if (res.or == 1) {
          let times = new Date(parseInt(res.in));
          // let creatDate = times.getFullYear() + '年-' + (times.getMonth() + 1) + '月-' + times.getDate() + '日-' + times.getHours() + '点-' + times.getMinutes() + '分-' + times.getSeconds()+'秒';
          this.in = times.toLocaleString();
          ;
        } else {
          let times = new Date(parseInt(res.out));
          // let creatDate = times.getFullYear() + '年-' + (times.getMonth() + 1) + '月-' + times.getDate() + '日-' + times.getHours() + '点-' + times.getMinutes() + '分-' + times.getSeconds()+'秒';
          this.out = times.toLocaleString();
          this.all = res.all;
        }
      } else {
        if (res.code == 1) {
          this.fail = "请登录学生账号。";
        } else if (res.code == 2) {
          this.fail = "二维码已过期。";
        } else if (res.code == 3) {
          this.fail = "暂无此场馆信息。";
        } else if (res.code == 4) {
          this.fail = "场馆，未开放。";
        } else if (res.code == 5) {
          this.fail = "场馆，已关闭。";
        } else if (res.code == 6) {
          this.fail = "您未预约。";
        } else if (res.code == 7) {
          this.fail = "你已经进出过。";
        } else if (res.code == 8) {
          this.fail = "系统异常，请联系管理员。";
        }
      }
    })
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    },
    imgShow() {
      ImagePreview({
        images: [
          'http://cdn.sport.hhstu.xyz/societies_lb2.png',
        ],
        closeable: true,
      });
    }
  }
}
</script>

<style scoped>
a {
  text-align: center;
}
</style>
